export enum BookingCommentTypeEnum {
    Default = "Default",
    Itinerary = "Itinerary",
    Manifest = "Manifest",
    Alert = "Alert",
    Archive = "Archive"
}
